import { UPLOAD_MAX_FILES, UPLOAD_MAX_FILE_SIZE_MB } from './constants';

export const UPLOAD_FILE_ERROR_MESSAGE = `Um ou mais arquivos excede o tamanho máximo de ${UPLOAD_MAX_FILE_SIZE_MB}MB`;
export const UPLOAD_FORMAT_ERROR_MESSAGE = `Este formato de arquivo não é permitido. Os formatos permitidos são: PDF, XLS, XLSX, DOC, DOCX, TXT, CSV e NOTES`;

export const UPLOAD_MAX_FILES_MESSAGE = `Máximo de ${UPLOAD_MAX_FILES} arquivos por lote de envio`;
export const UPLOAD_MAX_FILE_SIZE_MESSAGE = `Tamanho máx. do arquivo: ${UPLOAD_MAX_FILE_SIZE_MB}MB`;
